import api from '../utils/api';

// Download dos PDFs gerados no backend.
//
// A geração ficava aqui no navegador (utils/generateBoardingPDF, generateGEPDF)
// e passou para o servidor, para o documento que a tela baixa ser exatamente o
// mesmo que vai anexado no alerta de movimentação da portaria.

const baixar = async (url, nomePadrao) => {
    const token = localStorage.getItem('token');
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

    const resposta = await api.get(url, { responseType: 'blob' });

    // O nome vem no Content-Disposition; se faltar, usa o padrão.
    const disposition = resposta.headers?.['content-disposition'] || '';
    const nome = /filename="([^"]+)"/.exec(disposition)?.[1] || nomePadrao;

    const blobUrl = window.URL.createObjectURL(new Blob([resposta.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = nome;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
};

export const baixarNotaEmbarque = (requestId) =>
    baixar(`/documentos/nota-embarque/${requestId}`, 'nota-de-embarque.pdf');

export const baixarGuiaExpedicao = (collectOrderId) =>
    baixar(`/documentos/guia-expedicao/${collectOrderId}`, 'guia-de-expedicao.pdf');

const DocumentoService = { baixarNotaEmbarque, baixarGuiaExpedicao };

export default DocumentoService;
